<template>
  <div class="view">
    <Title title="イベント結果エクスポート"/>
    <EventClosedExportMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EventClosedExportMain from '@/components/EventClosed/ExportMain'

export default {
  components: {
    Title,
    EventClosedExportMain
  }
}
</script>

